import {useQuery} from "@tanstack/react-query";
import {usersInvitedGet} from "../api/users/usersInvitedGet.ts";

export const useUsersInvited = () => useQuery({
    queryKey: ['usersInvited'],
    queryFn: () => usersInvitedGet().then(r => r.payload)
})